/**
 * Tastiera su iOS: segnala con `html.kb-open` e `--kb-h` quando è aperta (solo app nativa).
 */
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

export function installKeyboard() {
  if (!Capacitor.isNativePlatform()) return;
  const root = document.documentElement;
  // iOS: la tastiera copre la webview (resize «none»): le finestre si alzano dell'altezza della tastiera.
  // Android: la webview si ridimensiona da sola sopra la tastiera → nessuno spostamento aggiuntivo (--kb-h = 0).
  const android = Capacitor.getPlatform() === "android";
  Keyboard.addListener("keyboardWillShow", (i) => { root.classList.add("kb-open"); root.style.setProperty("--kb-h", android ? "0px" : `${i.keyboardHeight}px`); });
  Keyboard.addListener("keyboardWillHide", () => { root.classList.remove("kb-open"); root.style.removeProperty("--kb-h"); });
}
